import { motion } from 'framer-motion';
import USDTIcon from '../../../assets/images/usdt/usdt-withdrawal.png';
import { formatNumbers } from '../../../helpers';
import { useAppSelector } from '../../../store';
import { useAnimatedCounter } from '../../../hooks/useAnimatedCounter';

type TUsdtBalanceProps = {
  onClick: () => void
}

function UsdtBalance({ onClick }: TUsdtBalanceProps) {
  const { userData } = useAppSelector(({ profile }) => profile);
  const { counter, isPulsing, isBlinking } = useAnimatedCounter(((userData?.usdt_balance || 0) / 10 ** 6));

  if (!userData) {
    return null;
  }

  return (
    <div
      className="
        relative
        h-[33px] w-max
        bg-[#013D3A]
        rounded-8
        ml-[27px] px-5
        flex items-center justify-center
        gradient-border header-usdt-balance before:rounded-8 z-[1]
        shadow-usdtBalance
      "
      onClick={onClick}
    >
      <div
        className="
            absolute
            top-[50%]
            left-0
            transform translate-x-[-28px] translate-y-[-50%]
        "
      >
        <img src={USDTIcon} alt="usdt icon" width={55} height={55} />
      </div>
      <motion.div
        initial={{ scale: 1 }}
        animate={{
          scale: isPulsing ? [1, 1.2, 1] : 1,
          opacity: isBlinking ? [1, 0, 1] : 1,
        }}
        transition={{
          duration: (isPulsing || isBlinking) ? 0.5 : 0,
          ease: 'easeInOut',
          // eslint-disable-next-line no-nested-ternary
          repeat: isPulsing ? Infinity : isBlinking ? 4 : 0,
          repeatType: 'loop',
          times: [0, 0.5, 1],
        }}
      >
        <span className="font-Bangers text-base">{formatNumbers((counter), 2, false)}</span>
      </motion.div>
    </div>
  );
}

export default UsdtBalance;
